var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreStartChecks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.652,
    height: 114.891,
    viewBox: "0 0 97.652 114.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: #db5a51;\n      }\n\n      .cls-4 {\n        fill: #4d2d3e;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-6 {\n        fill: #5b3439;\n      }\n\n      .cls-7 {\n        fill: #f0dbd0;\n      }\n\n      .cls-8 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-9 {\n        fill: #a97f7f;\n      }\n\n      .cls-10 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-12 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-13 {\n        fill: #fdb837;\n      }\n\n      .cls-14 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-15 {\n        fill: #b8d053;\n      }\n\n      .cls-16 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-17 {\n        fill: #fd5d5d;\n      }\n\n      .cls-18 {\n        opacity: 0.3;\n      }\n\n      .cls-18, .cls-99 {\n        mix-blend-mode: multiply;\n        isolation: isolate;\n      }\n\n      .cls-19 {\n        clip-path: url(#clip-path-11);\n      }\n\n      .cls-20 {\n        opacity: 0;\n      }\n\n      .cls-21 {\n        clip-path: url(#clip-path-12);\n      }\n\n      .cls-22 {\n        fill: #afb6e5;\n      }\n\n      .cls-23 {\n        opacity: 0.048;\n      }\n\n      .cls-24 {\n        clip-path: url(#clip-path-13);\n      }\n\n      .cls-25 {\n        fill: #abb2e2;\n      }\n\n      .cls-26 {\n        opacity: 0.095;\n      }\n\n      .cls-27 {\n        clip-path: url(#clip-path-14);\n      }\n\n      .cls-28 {\n        fill: #a7addf;\n      }\n\n      .cls-29 {\n        opacity: 0.143;\n      }\n\n      .cls-30 {\n        clip-path: url(#clip-path-15);\n      }\n\n      .cls-31 {\n        fill: #a3a9dc;\n      }\n\n      .cls-32 {\n        opacity: 0.19;\n      }\n\n      .cls-33 {\n        clip-path: url(#clip-path-16);\n      }\n\n      .cls-34 {\n        fill: #9fa4d8;\n      }\n\n      .cls-35 {\n        opacity: 0.238;\n      }\n\n      .cls-36 {\n        clip-path: url(#clip-path-17);\n      }\n\n      .cls-37 {\n        fill: #9ba0d5;\n      }\n\n      .cls-38 {\n        opacity: 0.286;\n      }\n\n      .cls-39 {\n        clip-path: url(#clip-path-18);\n      }\n\n      .cls-40 {\n        fill: #979bd2;\n      }\n\n      .cls-41 {\n        opacity: 0.333;\n      }\n\n      .cls-42 {\n        clip-path: url(#clip-path-19);\n      }\n\n      .cls-43 {\n        fill: #9397cf;\n      }\n\n      .cls-44 {\n        opacity: 0.381;\n      }\n\n      .cls-45 {\n        clip-path: url(#clip-path-20);\n      }\n\n      .cls-46 {\n        fill: #8f92cc;\n      }\n\n      .cls-47 {\n        opacity: 0.429;\n      }\n\n      .cls-48 {\n        clip-path: url(#clip-path-21);\n      }\n\n      .cls-49 {\n        fill: #8b8ec9;\n      }\n\n      .cls-50 {\n        opacity: 0.476;\n      }\n\n      .cls-51 {\n        clip-path: url(#clip-path-22);\n      }\n\n      .cls-52 {\n        fill: #8789c6;\n      }\n\n      .cls-53 {\n        opacity: 0.524;\n      }\n\n      .cls-54 {\n        clip-path: url(#clip-path-23);\n      }\n\n      .cls-55 {\n        fill: #8385c2;\n      }\n\n      .cls-56 {\n        opacity: 0.571;\n      }\n\n      .cls-57 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-58 {\n        fill: #7f80bf;\n      }\n\n      .cls-59 {\n        opacity: 0.619;\n      }\n\n      .cls-60 {\n        clip-path: url(#clip-path-25);\n      }\n\n      .cls-61 {\n        fill: #7b7cbc;\n      }\n\n      .cls-62 {\n        opacity: 0.667;\n      }\n\n      .cls-63 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-64 {\n        fill: #7777b9;\n      }\n\n      .cls-65 {\n        opacity: 0.714;\n      }\n\n      .cls-66 {\n        clip-path: url(#clip-path-27);\n      }\n\n      .cls-67 {\n        fill: #7373b6;\n      }\n\n      .cls-68 {\n        opacity: 0.762;\n      }\n\n      .cls-69 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-70 {\n        fill: #6f6eb3;\n      }\n\n      .cls-71 {\n        opacity: 0.81;\n      }\n\n      .cls-72 {\n        clip-path: url(#clip-path-29);\n      }\n\n      .cls-73 {\n        fill: #6b6ab0;\n      }\n\n      .cls-74 {\n        opacity: 0.857;\n      }\n\n      .cls-75 {\n        clip-path: url(#clip-path-30);\n      }\n\n      .cls-76 {\n        fill: #6765ac;\n      }\n\n      .cls-77 {\n        opacity: 0.905;\n      }\n\n      .cls-78 {\n        clip-path: url(#clip-path-31);\n      }\n\n      .cls-79 {\n        fill: #6361a9;\n      }\n\n      .cls-80 {\n        opacity: 0.952;\n      }\n\n      .cls-81 {\n        clip-path: url(#clip-path-32);\n      }\n\n      .cls-82 {\n        fill: #5f5ca6;\n      }\n\n      .cls-83 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-84 {\n        fill: #5b58a3;\n      }\n\n      .cls-85 {\n        clip-path: url(#clip-path-34);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-87 {\n        clip-path: url(#clip-path-36);\n      }\n\n      .cls-88 {\n        fill: #f7ebdc;\n      }\n\n      .cls-89 {\n        fill: #865663;\n      }\n\n      .cls-90 {\n        fill: #fff8ef;\n      }\n\n      .cls-91 {\n        clip-path: url(#clip-path-38);\n      }\n\n      .cls-92 {\n        fill: #769137;\n      }\n\n      .cls-93 {\n        clip-path: url(#clip-path-40);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-95 {\n        fill: #ffebe0;\n      }\n\n      .cls-96 {\n        fill: #f2635a;\n      }\n\n      .cls-97 {\n        opacity: 0.8;\n      }\n\n      .cls-98 {\n        clip-path: url(#clip-path-42);\n      }\n\n      .cls-100 {\n        clip-path: url(#clip-path-43);\n      }\n\n      .cls-101 {\n        fill: #834242;\n      }\n\n      .cls-102 {\n        clip-path: url(#clip-path-44);\n      }\n\n      .cls-103 {\n        fill: #e2b2af;\n      }\n\n      .cls-104 {\n        fill: #86b161;\n      }\n\n      .cls-105 {\n        clip-path: url(#clip-path-45);\n      }\n\n      .cls-106 {\n        clip-path: url(#clip-path-46);\n      }\n\n      .cls-107 {\n        fill: #436542;\n      }\n\n      .cls-108 {\n        clip-path: url(#clip-path-47);\n      }\n\n      .cls-109 {\n        fill: #afc6e5;\n      }\n\n      .cls-110 {\n        opacity: 0.065;\n      }\n\n      .cls-111 {\n        clip-path: url(#clip-path-48);\n      }\n\n      .cls-112 {\n        clip-path: url(#clip-path-49);\n      }\n\n      .cls-113 {\n        clip-path: url(#clip-path-50);\n      }\n\n      .cls-114 {\n        fill: #ef5b0c;\n      }\n\n      .cls-115 {\n        fill: #f46c08;\n      }\n\n      .cls-116 {\n        fill: #ffd298;\n      }\n\n      .cls-117 {\n        fill: #ff7e10;\n      }\n\n      .cls-118 {\n        fill: #f7c59b;\n      }\n\n      .cls-119 {\n        fill: #ffd4b5;\n      }\n\n      .cls-120 {\n        fill: #4c2925;\n      }\n\n      .cls-121 {\n        fill: #f3a34d;\n      }\n\n      .cls-122 {\n        fill: #ffc273;\n      }\n\n      .cls-123 {\n        fill: #f8b15d;\n      }\n\n      .cls-124 {\n        fill: #ec8d2f;\n      }\n\n      .cls-125 {\n        fill: #ffddb8;\n      }\n\n      .cls-126 {\n        fill: #ff6010;\n      }\n\n      .cls-127 {\n        fill: #d9382e;\n      }\n\n      .cls-128 {\n        fill: #59312e;\n      }\n\n      .cls-129 {\n        fill: #fff4de;\n      }\n\n      .cls-130 {\n        fill: #78a8cd;\n      }\n\n      .cls-131 {\n        fill: #8eceff;\n      }\n\n      .cls-132 {\n        fill: #683937;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.425,
    y1: 0.942,
    x2: 0.451,
    y2: 0.129,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde2ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25492",
    "data-name": "Rectangle 25492",
    className: "cls-1",
    width: 70,
    height: 114.891
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72030",
    "data-name": "Path 72030",
    className: "cls-1",
    d: "M68.237,12.07V90.441c0,4.23,2.563,9.149,5.713,10.968l29.429,16.99a4.225,4.225,0,0,0,2.088.642c1.84,0,3.029-1.833,3.029-4.67V36c0-4.23-2.563-9.15-5.713-10.968L73.354,8.041A4.225,4.225,0,0,0,71.266,7.4c-1.84,0-3.029,1.833-3.029,4.67",
    transform: "translate(-68.237 -7.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72032",
    "data-name": "Path 72032",
    className: "cls-1",
    d: "M73.76,18.5V97.452a9.159,9.159,0,0,0,4.156,7.17L105.9,120.778c2.3,1.326,4.156.265,4.156-2.37V39.46a9.159,9.159,0,0,0-4.156-7.17L77.916,16.134a3.79,3.79,0,0,0-1.866-.571c-1.359,0-2.291,1.076-2.291,2.941",
    transform: "translate(-73.76 -15.563)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.979,
    y1: 0.196,
    x2: 0.078,
    y2: 0.889,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c628d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502f65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72034",
    "data-name": "Path 72034",
    className: "cls-1",
    d: "M118.646,254.269l-2.907-1.678a.765.765,0,0,1-.347-.6c0-.22.155-.309.347-.2l2.907,1.679a.765.765,0,0,1,.348.6c0,.156-.078.246-.192.246a.313.313,0,0,1-.156-.048m-.163-2.928a1.408,1.408,0,0,1-.638-1.1c0-.4.286-.568.638-.364a1.407,1.407,0,0,1,.638,1.1c0,.287-.143.452-.352.452a.584.584,0,0,1-.286-.087M115.9,249.85a1.406,1.406,0,0,1-.638-1.1c0-.4.286-.567.638-.364a1.406,1.406,0,0,1,.638,1.1c0,.286-.143.452-.352.452a.583.583,0,0,1-.287-.088m-3.1-1.333a9.682,9.682,0,0,0,4.388,7.569c2.42,1.4,4.388.275,4.388-2.5a9.684,9.684,0,0,0-4.388-7.569,4,4,0,0,0-1.966-.6c-1.436,0-2.423,1.137-2.423,3.1",
    transform: "translate(-112.804 -245.415)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72035",
    "data-name": "Path 72035",
    className: "cls-1",
    d: "M86.642,236.868a5.688,5.688,0,0,1-2.247-2.813c-.093-.243-.01-.436.166-.413a.593.593,0,0,1,.39.39,4.289,4.289,0,0,0,1.691,2.111c.726.419,1.386.333,1.717-.2.074-.118.237-.1.386.046a.581.581,0,0,1,.179.607,1.27,1.27,0,0,1-1.128.623,2.345,2.345,0,0,1-1.154-.351m1.3-3.159a1.407,1.407,0,0,1-.638-1.1c0-.4.286-.567.638-.364a1.405,1.405,0,0,1,.638,1.1c0,.286-.143.452-.351.452a.583.583,0,0,1-.287-.088m-2.582-1.491a1.406,1.406,0,0,1-.638-1.1c0-.4.286-.567.638-.364a1.407,1.407,0,0,1,.638,1.1c0,.286-.143.452-.352.452a.578.578,0,0,1-.287-.088m-3.1-1.332a9.684,9.684,0,0,0,4.388,7.569c2.42,1.4,4.388.274,4.388-2.5a9.684,9.684,0,0,0-4.388-7.57,4,4,0,0,0-1.966-.6c-1.436,0-2.423,1.137-2.423,3.1",
    transform: "translate(-82.265 -227.783)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72036",
    "data-name": "Path 72036",
    className: "cls-1",
    d: "M145.233,270.475a.581.581,0,0,1-.179-.607c.438-.711,1.316-.829,2.281-.271a5.686,5.686,0,0,1,2.247,2.813c.093.243.01.436-.166.413h0a.591.591,0,0,1-.39-.39,4.287,4.287,0,0,0-1.691-2.111c-.726-.419-1.386-.333-1.717.2a.159.159,0,0,1-.141.078.371.371,0,0,1-.245-.124m3.374-1.627a1.407,1.407,0,0,1-.639-1.1c0-.4.286-.568.639-.364a1.408,1.408,0,0,1,.638,1.1c0,.286-.143.452-.352.452a.58.58,0,0,1-.286-.087m-2.582-1.491a1.406,1.406,0,0,1-.638-1.1c0-.4.286-.567.638-.364a1.407,1.407,0,0,1,.639,1.1c0,.286-.143.452-.352.452a.583.583,0,0,1-.287-.088m-3.1-1.333a9.682,9.682,0,0,0,4.388,7.569c2.419,1.4,4.388.275,4.388-2.5a9.684,9.684,0,0,0-4.388-7.569,3.992,3.992,0,0,0-1.966-.6c-1.435,0-2.422,1.137-2.422,3.1",
    transform: "translate(-142.928 -262.922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25471",
    "data-name": "Rectangle 25471",
    className: "cls-1",
    width: 34.138,
    height: 58.299
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25449",
    "data-name": "Rectangle 25449",
    className: "cls-1",
    width: 33.167,
    height: 58.299
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25450",
    "data-name": "Rectangle 25450",
    className: "cls-1",
    width: 32.972,
    height: 57.882
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25451",
    "data-name": "Rectangle 25451",
    className: "cls-1",
    width: 32.784,
    height: 57.47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25452",
    "data-name": "Rectangle 25452",
    className: "cls-1",
    width: 32.607,
    height: 57.061
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25453",
    "data-name": "Rectangle 25453",
    className: "cls-1",
    width: 32.44,
    height: 56.656
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25454",
    "data-name": "Rectangle 25454",
    className: "cls-1",
    width: 32.285,
    height: 56.257
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25455",
    "data-name": "Rectangle 25455",
    className: "cls-1",
    width: 32.144,
    height: 55.863
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25456",
    "data-name": "Rectangle 25456",
    className: "cls-1",
    width: 32.018,
    height: 55.476
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25457",
    "data-name": "Rectangle 25457",
    className: "cls-1",
    width: 31.906,
    height: 55.096
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25458",
    "data-name": "Rectangle 25458",
    className: "cls-1",
    width: 31.804,
    height: 54.725
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25459",
    "data-name": "Rectangle 25459",
    className: "cls-1",
    width: 31.706,
    height: 54.365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25460",
    "data-name": "Rectangle 25460",
    className: "cls-1",
    width: 31.607,
    height: 54.017
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25461",
    "data-name": "Rectangle 25461",
    className: "cls-1",
    width: 31.509,
    height: 53.683
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25462",
    "data-name": "Rectangle 25462",
    className: "cls-1",
    width: 31.41,
    height: 53.365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25463",
    "data-name": "Rectangle 25463",
    className: "cls-1",
    width: 31.311,
    height: 53.067
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25464",
    "data-name": "Rectangle 25464",
    className: "cls-1",
    width: 31.213,
    height: 52.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25465",
    "data-name": "Rectangle 25465",
    className: "cls-1",
    width: 31.114,
    height: 52.538
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25466",
    "data-name": "Rectangle 25466",
    className: "cls-1",
    width: 31.015,
    height: 52.312
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25467",
    "data-name": "Rectangle 25467",
    className: "cls-1",
    width: 30.917,
    height: 52.114
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25468",
    "data-name": "Rectangle 25468",
    className: "cls-1",
    width: 30.818,
    height: 51.942
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25469",
    "data-name": "Rectangle 25469",
    className: "cls-1",
    width: 30.719,
    height: 51.795
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25470",
    "data-name": "Rectangle 25470",
    className: "cls-1",
    width: 30.621,
    height: 51.67
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72059",
    "data-name": "Path 72059",
    className: "cls-2",
    d: "M47.133,91.427c0,.407-.023,33.034-.023,33.072a7.6,7.6,0,0,1-2.894,5.532c2.807,1.621,19.3,11.029,24.088,13.794a4.235,4.235,0,0,0,1.136.813c.02.015,2.159,1.051,3.405,1.656,0,.576,0,.938,0,.948,0,1.347.594,2.193,1.5,2.374l.014,0a1.866,1.866,0,0,0,.232.028c.051,0,.1,0,.156,0,.036,0,.072,0,.109,0a3.224,3.224,0,0,0,1.365-.459,6.014,6.014,0,0,0,1.444-1.205,4.867,4.867,0,0,0,1.223-1.814,6.624,6.624,0,0,0,.741-2.858c0-.017.025-.361.025-.777,0-.2.012-24.513.015-33.2,0-.011,0-.024,0-.035l-32.3-18.6Z",
    transform: "translate(-44.216 -90.688)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.9,
    y1: 0.374,
    x2: 0.024,
    y2: 0.388,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bba9c9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72061",
    "data-name": "Path 72061",
    className: "cls-1",
    d: "M30.643,191.341a2.514,2.514,0,0,0,1.211,2.229l33.309,19.087L65.1,212.6a2.364,2.364,0,0,1-.842-2.031,5.959,5.959,0,0,1,.422-2.091L31.549,189.547l-.493-.275a5.946,5.946,0,0,0-.413,2.069",
    transform: "translate(-30.643 -189.272)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72072",
    "data-name": "Path 72072",
    className: "cls-3",
    d: "M65.286,181.443l-.739.421c-.072.041-.072.174,0,.3l1.1,1.9-1.037.591c-.071.041-.071.174,0,.3l.739,1.274c.072.123.188.19.259.15l1.037-.591,1.1,1.9c.071.123.187.19.259.15l.739-.421c.071-.041.071-.174,0-.3l-1.1-1.9,1.1-.627c.071-.041.071-.174,0-.3L68,183.011c-.072-.123-.188-.19-.259-.149l-1.1.627-1.1-1.9a.288.288,0,0,0-.212-.161.092.092,0,0,0-.047.012",
    transform: "translate(-64.493 -181.431)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72076",
    "data-name": "Path 72076",
    className: "cls-1",
    d: "M38.143,15.021V31.67c0,2.887,1.808,6.369,3.947,7.6L79.616,61.029a2.76,2.76,0,0,0,1.357.422,1.529,1.529,0,0,0,1.3-.7,4.116,4.116,0,0,0,.6-2.362V41.737c0-2.887-1.808-6.369-3.948-7.6L41.393,12.377a2.758,2.758,0,0,0-1.357-.422c-1.15,0-1.893,1.2-1.893,3.066",
    transform: "translate(-38.143 -11.955)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.941,
    y1: 0.62,
    x2: 0.163,
    y2: 0.464,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99c367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#416dbf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25487",
    "data-name": "Rectangle 25487",
    className: "cls-1",
    width: 8.671,
    height: 10.933
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25485",
    "data-name": "Rectangle 25485",
    className: "cls-1",
    width: 8.67,
    height: 10.933
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25486",
    "data-name": "Rectangle 25486",
    className: "cls-1",
    width: 7.693,
    height: 10.925
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25490",
    "data-name": "Rectangle 25490",
    className: "cls-1",
    width: 5.643,
    height: 7.115
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25488",
    "data-name": "Rectangle 25488",
    className: "cls-1",
    width: 5.642,
    height: 7.115
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25489",
    "data-name": "Rectangle 25489",
    className: "cls-1",
    width: 5.006,
    height: 7.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25484",
    "data-name": "Rectangle 25484",
    className: "cls-4",
    width: 9.523,
    height: 19.667
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72087",
    "data-name": "Path 72087",
    className: "cls-4",
    d: "M41.548,61.208,36.2,58.1c0,.113,0,3.422.009,3.536.141,3.075,2.006,6.521,4.286,7.837l1.548.9-.052.156c0,.148,0,1.387-.007,6.962,2.1.921,3.74-.5,3.74-3.38V69.19c0-3.076-1.87-6.65-4.178-7.982",
    transform: "translate(-36.203 -58.098)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25378",
    "data-name": "Rectangle 25378",
    className: "cls-1",
    width: 24.558,
    height: 66.084
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pre-Start_Checks",
    "data-name": "Pre-Start Checks",
    transform: "translate(-1347.29 -521.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68035",
    "data-name": "Group 68035",
    transform: "translate(1374.942 521.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68031",
    "data-name": "Group 68031",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67899",
    "data-name": "Group 67899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67898",
    "data-name": "Group 67898",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72028",
    "data-name": "Path 72028",
    className: "cls-6",
    d: "M109.763,17.622,80.335.632A4.341,4.341,0,0,0,76.271.4l0,0L76.2.422l0,0-.068.025,0,0-.069.025,0,0L75.981.5l0,0L75.908.53l0,0-.069.025,0,0-.069.025h0L75.69.61l0,0-.069.025h0l-.069.025h0l-.069.025h0L75.4.718h0l-.07.025h0l-.07.025h0L75.183.8h0l-.07.026h0l-.07.025h0l-.07.026h0l-.07.025h0l-.07.026h0l-.07.026c-.048.018-2.822,1.374-3,1.47l-.016.009c-1.121.809.729,1.306.729,3.557V84.367c0,4.426,2.691,9.568,6.011,11.484L107.9,112.842c1.451.838-.3,2.162.775,1.8.08-.027,5.058-2.328,5.129-2.373,1.21-.767,1.97-2.444,1.97-4.8V29.107c0-4.426-2.691-9.568-6.011-11.484",
    transform: "translate(-45.774 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72029",
    "data-name": "Path 72029",
    className: "cls-7",
    d: "M102.016,117.851,72.588,100.86c-3.32-1.916-6.011-7.058-6.011-11.484V11c0-4.426,2.691-6.46,6.011-4.544l29.428,16.99c3.32,1.917,6.011,7.058,6.011,11.484v78.372c0,4.426-2.691,6.46-6.011,4.544",
    transform: "translate(-42.699 -3.681)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67903",
    "data-name": "Group 67903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67902",
    "data-name": "Group 67902",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72031",
    "data-name": "Path 72031",
    className: "cls-9",
    d: "M72.127,95.205V17.135c0-3.248,1.975-4.741,4.41-3.334l28.648,16.54c2.436,1.406,4.41,5.179,4.41,8.427v78.07c0,3.248-1.974,4.74-4.41,3.334l-28.648-16.54c-2.436-1.406-4.41-5.179-4.41-8.427",
    transform: "translate(-46.259 -8.512)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67905",
    "data-name": "Group 67905",
    transform: "translate(26.454 5.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67904",
    "data-name": "Group 67904",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25444",
    "data-name": "Rectangle 25444",
    className: "cls-11",
    width: 68.027,
    height: 112.551,
    transform: "translate(-31.869 10.584) rotate(-18.372)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67907",
    "data-name": "Group 67907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67906",
    "data-name": "Group 67906",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72033",
    "data-name": "Path 72033",
    className: "cls-7",
    d: "M185.71,139.938h0c-.844.487-1.529-.03-1.529-1.156V132.4a3.662,3.662,0,0,1,1.529-2.921c.844-.487,1.529.03,1.529,1.156v6.377a3.662,3.662,0,0,1-1.529,2.921",
    transform: "translate(-118.125 -82.927)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67909",
    "data-name": "Group 67909",
    transform: "translate(40.457 88.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67908",
    "data-name": "Group 67908",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25446",
    "data-name": "Rectangle 25446",
    className: "cls-13",
    width: 8.777,
    height: 12.069,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67911",
    "data-name": "Group 67911",
    transform: "translate(29.504 81.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67910",
    "data-name": "Group 67910",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25447",
    "data-name": "Rectangle 25447",
    className: "cls-15",
    width: 14.785,
    height: 13.44,
    transform: "matrix(0.473, -0.881, 0.881, 0.473, -5.028, 9.371)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67913",
    "data-name": "Group 67913",
    transform: "translate(51.261 94.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67912",
    "data-name": "Group 67912",
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25448",
    "data-name": "Rectangle 25448",
    className: "cls-17",
    width: 8.776,
    height: 12.069
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67984",
    "data-name": "Group 67984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67983",
    "data-name": "Group 67983",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67982",
    "data-name": "Group 67982",
    className: "cls-18",
    transform: "translate(20.355 35.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67981",
    "data-name": "Group 67981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67980",
    "data-name": "Group 67980",
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67916",
    "data-name": "Group 67916",
    className: "cls-20",
    transform: "translate(0.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67915",
    "data-name": "Group 67915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67914",
    "data-name": "Group 67914",
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72037",
    "data-name": "Path 72037",
    className: "cls-22",
    d: "M73.442,105.009c-2.665-1.539-13.507-8.333-13.507-5.275v29.325c0,3.057-1.6,13.526,1.067,15.064l21.975,12.862c2.665,1.539,9.65-3.976,9.65-7.033V118c0-3.057-5.211-5.2-7.876-6.743Z",
    transform: "translate(-59.461 -98.952)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67919",
    "data-name": "Group 67919",
    className: "cls-23",
    transform: "translate(0.998 0.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67918",
    "data-name": "Group 67918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67917",
    "data-name": "Group 67917",
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72038",
    "data-name": "Path 72038",
    className: "cls-25",
    d: "M73.006,105.035c-2.663-1.538-13.09-7.95-13.09-4.895v29.219c0,3.056-1.42,13.2,1.243,14.738l21.933,12.838c2.663,1.538,9.417-3.772,9.417-6.828V118.385c0-3.056-5.064-5.275-7.727-6.813Z",
    transform: "translate(-59.538 -99.326)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67922",
    "data-name": "Group 67922",
    className: "cls-26",
    transform: "translate(1.018 0.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67921",
    "data-name": "Group 67921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67920",
    "data-name": "Group 67920",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72039",
    "data-name": "Path 72039",
    className: "cls-28",
    d: "M72.557,105.056c-2.661-1.536-12.674-7.568-12.674-4.514v29.111c0,3.054-1.242,12.875,1.419,14.412l21.892,12.814c2.661,1.537,9.184-3.568,9.184-6.622v-31.49c0-3.054-4.918-5.346-7.579-6.882Z",
    transform: "translate(-59.593 -99.691)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67925",
    "data-name": "Group 67925",
    className: "cls-29",
    transform: "translate(1.028 0.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67924",
    "data-name": "Group 67924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67923",
    "data-name": "Group 67923",
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72040",
    "data-name": "Path 72040",
    className: "cls-31",
    d: "M72.089,105.072c-2.659-1.535-12.257-7.185-12.257-4.134v29.006c0,3.051-1.065,12.549,1.594,14.085l21.851,12.79c2.659,1.535,8.951-3.365,8.951-6.416V119.143c0-3.052-4.771-5.417-7.43-6.952Z",
    transform: "translate(-59.622 -100.048)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67928",
    "data-name": "Group 67928",
    className: "cls-32",
    transform: "translate(1.028 0.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67927",
    "data-name": "Group 67927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67926",
    "data-name": "Group 67926",
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72041",
    "data-name": "Path 72041",
    className: "cls-34",
    d: "M71.6,105.08c-2.658-1.534-11.84-6.8-11.84-3.754v28.9c0,3.05-.888,12.224,1.77,13.758l21.809,12.766c2.658,1.534,8.718-3.161,8.718-6.21V119.512c0-3.05-4.624-5.488-7.282-7.022Z",
    transform: "translate(-59.621 -100.393)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67931",
    "data-name": "Group 67931",
    className: "cls-35",
    transform: "translate(1.015 0.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67930",
    "data-name": "Group 67930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67929",
    "data-name": "Group 67929",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72042",
    "data-name": "Path 72042",
    className: "cls-37",
    d: "M71.094,105.081c-2.656-1.533-11.424-6.421-11.424-3.373V130.5c0,3.047-.71,11.9,1.946,13.432l21.768,12.742c2.656,1.533,8.485-2.957,8.485-6v-30.8c0-3.047-4.478-5.558-7.133-7.092Z",
    transform: "translate(-59.585 -100.727)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67934",
    "data-name": "Group 67934",
    className: "cls-38",
    transform: "translate(0.989 0.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67933",
    "data-name": "Group 67933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67932",
    "data-name": "Group 67932",
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72043",
    "data-name": "Path 72043",
    className: "cls-40",
    d: "M70.563,105.072c-2.654-1.532-11.007-6.039-11.007-2.993v28.685c0,3.046-.533,11.573,2.121,13.105L83.4,156.587c2.654,1.533,8.252-2.753,8.252-5.8V120.225c0-3.045-4.331-5.629-6.985-7.161Z",
    transform: "translate(-59.512 -101.046)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67937",
    "data-name": "Group 67937",
    className: "cls-41",
    transform: "translate(0.948 0.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67936",
    "data-name": "Group 67936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67935",
    "data-name": "Group 67935",
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72044",
    "data-name": "Path 72044",
    className: "cls-43",
    d: "M70,105.054c-2.652-1.531-10.59-5.656-10.59-2.612V131.02c0,3.043-.355,11.247,2.3,12.779L83.4,156.492c2.653,1.531,8.019-2.55,8.019-5.593V120.568c0-3.043-4.184-5.7-6.837-7.231Z",
    transform: "translate(-59.397 -101.349)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67940",
    "data-name": "Group 67940",
    className: "cls-44",
    transform: "translate(0.892 0.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67939",
    "data-name": "Group 67939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67938",
    "data-name": "Group 67938",
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72045",
    "data-name": "Path 72045",
    className: "cls-46",
    d: "M69.419,105.022c-2.65-1.53-10.174-5.274-10.174-2.232v28.472c0,3.041-.178,10.922,2.473,12.452l21.643,12.67c2.651,1.53,7.787-2.346,7.787-5.387V120.9c0-3.041-4.038-5.77-6.688-7.3Z",
    transform: "translate(-59.243 -101.633)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67943",
    "data-name": "Group 67943",
    className: "cls-47",
    transform: "translate(0.826 1.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67942",
    "data-name": "Group 67942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67941",
    "data-name": "Group 67941",
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72046",
    "data-name": "Path 72046",
    className: "cls-49",
    d: "M68.815,104.978c-2.649-1.529-9.757-4.891-9.757-1.852v28.365c0,3.04,0,10.6,2.649,12.125l21.6,12.646c2.649,1.529,7.553-2.142,7.553-5.182V121.213c0-3.04-3.891-5.841-6.539-7.37Z",
    transform: "translate(-59.058 -101.896)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67946",
    "data-name": "Group 67946",
    className: "cls-50",
    transform: "translate(0.757 1.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67945",
    "data-name": "Group 67945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67944",
    "data-name": "Group 67944",
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72047",
    "data-name": "Path 72047",
    className: "cls-52",
    d: "M68.207,104.916c-2.647-1.528-9.341-4.509-9.341-1.472V131.7c0,3.037.178,10.27,2.825,11.8l21.561,12.622c2.647,1.528,7.32-1.938,7.32-4.976V121.512c0-3.037-3.744-5.912-6.391-7.44Z",
    transform: "translate(-58.866 -102.132)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67949",
    "data-name": "Group 67949",
    className: "cls-53",
    transform: "translate(0.688 1.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67948",
    "data-name": "Group 67948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67947",
    "data-name": "Group 67947",
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72048",
    "data-name": "Path 72048",
    className: "cls-55",
    d: "M67.6,104.835c-2.645-1.527-8.924-4.127-8.924-1.091V131.9c0,3.035.355,9.945,3,11.472l21.519,12.6c2.645,1.527,7.088-1.735,7.088-4.77v-29.4c0-3.036-3.6-5.983-6.243-7.51Z",
    transform: "translate(-58.674 -102.338)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67952",
    "data-name": "Group 67952",
    className: "cls-56",
    transform: "translate(0.62 1.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67951",
    "data-name": "Group 67951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67950",
    "data-name": "Group 67950",
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72049",
    "data-name": "Path 72049",
    className: "cls-58",
    d: "M66.989,104.731c-2.644-1.526-8.507-3.744-8.507-.711v28.046c0,3.033.533,9.619,3.176,11.146l21.478,12.574c2.644,1.526,6.854-1.531,6.854-4.564V122.048c0-3.033-3.451-6.053-6.094-7.579Z",
    transform: "translate(-58.482 -102.508)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67955",
    "data-name": "Group 67955",
    className: "cls-59",
    transform: "translate(0.551 1.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67954",
    "data-name": "Group 67954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67953",
    "data-name": "Group 67953",
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72050",
    "data-name": "Path 72050",
    className: "cls-61",
    d: "M66.381,104.6c-2.642-1.525-8.091-3.362-8.091-.33v27.939c0,3.032.71,9.294,3.352,10.819l21.436,12.55c2.642,1.525,6.622-1.327,6.622-4.359V122.279c0-3.031-3.3-6.124-5.946-7.649Z",
    transform: "translate(-58.29 -102.637)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67958",
    "data-name": "Group 67958",
    className: "cls-62",
    transform: "translate(0.482 1.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67957",
    "data-name": "Group 67957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67956",
    "data-name": "Group 67956",
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72051",
    "data-name": "Path 72051",
    className: "cls-64",
    d: "M65.773,104.438c-2.64-1.524-7.674-2.979-7.674.05V132.32c0,3.029.887,8.968,3.527,10.492l21.4,12.526c2.64,1.524,6.389-1.124,6.389-4.153V122.477c0-3.029-3.157-6.195-5.8-7.719Z",
    transform: "translate(-58.099 -102.716)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67961",
    "data-name": "Group 67961",
    className: "cls-65",
    transform: "translate(0.413 1.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67960",
    "data-name": "Group 67960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67959",
    "data-name": "Group 67959",
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72052",
    "data-name": "Path 72052",
    className: "cls-67",
    d: "M65.164,104.24c-2.638-1.523-7.258-2.6-7.258.43V132.4c0,3.027,1.065,8.643,3.7,10.166l21.354,12.5c2.638,1.523,6.155-.92,6.155-3.947V122.64c0-3.027-3.01-6.265-5.649-7.788Z",
    transform: "translate(-57.906 -102.74)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67964",
    "data-name": "Group 67964",
    className: "cls-68",
    transform: "translate(0.344 1.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67963",
    "data-name": "Group 67963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67962",
    "data-name": "Group 67962",
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72053",
    "data-name": "Path 72053",
    className: "cls-70",
    d: "M64.555,104c-2.636-1.522-6.841-2.215-6.841.811v27.619c0,3.026,1.243,8.317,3.879,9.839l21.312,12.478c2.636,1.522,5.923-.716,5.923-3.741V122.763c0-3.025-2.864-6.336-5.5-7.858Z",
    transform: "translate(-57.714 -102.702)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67967",
    "data-name": "Group 67967",
    className: "cls-71",
    transform: "translate(0.275 1.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67966",
    "data-name": "Group 67966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67965",
    "data-name": "Group 67965",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72054",
    "data-name": "Path 72054",
    className: "cls-73",
    d: "M63.946,103.721c-2.635-1.521-6.424-1.832-6.424,1.191v27.513c0,3.023,1.42,7.992,4.055,9.513l21.271,12.454a3.833,3.833,0,0,0,5.69-3.536V122.843c0-3.024-2.717-6.407-5.352-7.928Z",
    transform: "translate(-57.522 -102.596)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67970",
    "data-name": "Group 67970",
    className: "cls-74",
    transform: "translate(0.207 1.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67969",
    "data-name": "Group 67969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67968",
    "data-name": "Group 67968",
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72055",
    "data-name": "Path 72055",
    className: "cls-76",
    d: "M63.338,103.4c-2.633-1.52-6.008-1.45-6.008,1.572v27.406c0,3.021,1.6,7.666,4.231,9.186L82.79,153.99c2.633,1.52,5.457-.308,5.457-3.33V122.879c0-3.021-2.57-6.478-5.2-8Z",
    transform: "translate(-57.33 -102.422)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67973",
    "data-name": "Group 67973",
    className: "cls-77",
    transform: "translate(0.138 1.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67972",
    "data-name": "Group 67972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67971",
    "data-name": "Group 67971",
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72056",
    "data-name": "Path 72056",
    className: "cls-79",
    d: "M62.73,103.029c-2.631-1.519-5.591-1.067-5.591,1.952v27.3c0,3.019,1.775,7.34,4.406,8.86l21.188,12.406c2.631,1.519,5.224-.1,5.224-3.124V122.872c0-3.019-2.423-6.548-5.055-8.067Z",
    transform: "translate(-57.139 -102.182)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67976",
    "data-name": "Group 67976",
    className: "cls-80",
    transform: "translate(0.069 1.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67975",
    "data-name": "Group 67975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67974",
    "data-name": "Group 67974",
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72057",
    "data-name": "Path 72057",
    className: "cls-82",
    d: "M62.121,102.624c-2.63-1.518-5.175-.685-5.175,2.332v27.193c0,3.017,1.953,7.015,4.582,8.533l21.147,12.382c2.63,1.518,4.991.1,4.991-2.918V122.828a10.513,10.513,0,0,0-4.906-8.137Z",
    transform: "translate(-56.946 -101.883)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67979",
    "data-name": "Group 67979",
    transform: "translate(0 0.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67978",
    "data-name": "Group 67978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67977",
    "data-name": "Group 67977",
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72058",
    "data-name": "Path 72058",
    className: "cls-84",
    d: "M61.513,102.185c-2.628-1.517-4.758-.3-4.758,2.713v27.086a10.484,10.484,0,0,0,4.758,8.207l21.1,12.358c2.628,1.517,4.758.3,4.758-2.713V122.75a10.484,10.484,0,0,0-4.758-8.207Z",
    transform: "translate(-56.755 -101.532)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67986",
    "data-name": "Group 67986",
    transform: "translate(15.858 32.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67985",
    "data-name": "Group 67985",
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25473",
    "data-name": "Rectangle 25473",
    className: "cls-86",
    width: 68.789,
    height: 60.186,
    transform: "translate(-12.365 63.875) rotate(-90)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67995",
    "data-name": "Group 67995",
    transform: "translate(10.99 67.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67994",
    "data-name": "Group 67994",
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25477",
    "data-name": "Rectangle 25477",
    className: "cls-88",
    width: 37.641,
    height: 41.608,
    transform: "translate(-10.209 17.392) rotate(-59.589)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67997",
    "data-name": "Group 67997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67996",
    "data-name": "Group 67996",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72062",
    "data-name": "Path 72062",
    className: "cls-89",
    d: "M89.325,198.028l5.712,3.4v-1.276l-5.712-3.4Zm-.912-1.8L83.906,193.6v1.276l4.507,2.627Zm4.856-.038-9.363-5.533v1.276l9.363,5.533Z",
    transform: "translate(-53.813 -122.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72063",
    "data-name": "Path 72063",
    className: "cls-90",
    d: "M67.832,179.984l-5.791-3.5c0,1.852,0,5.47,0,6.628l5.793,3.319Z",
    transform: "translate(-39.789 -113.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72064",
    "data-name": "Path 72064",
    className: "cls-89",
    d: "M67.832,185.83,62.3,182.66c0-1.029,0-4.455,0-6.026l-.258-.151c0,1.852,0,5.469,0,6.628l5.793,3.32Z",
    transform: "translate(-39.789 -113.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72065",
    "data-name": "Path 72065",
    className: "cls-89",
    d: "M87.941,166.27l5.274,3.137v-1.276l-5.274-3.137Zm3.6-.821,9.664,5.66v-1.276l-9.664-5.66Zm-4.514-.982-3.122-1.8v1.276l3.122,1.8Zm3.6-.821-6.724-3.922V161l6.724,3.923Z",
    transform: "translate(-53.813 -102.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72066",
    "data-name": "Path 72066",
    className: "cls-90",
    d: "M67.832,149.054l-5.791-3.5c0,1.852,0,5.47,0,6.628l5.793,3.319Z",
    transform: "translate(-39.789 -93.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72067",
    "data-name": "Path 72067",
    className: "cls-89",
    d: "M67.832,154.9,62.3,151.73c0-1.029,0-4.455,0-6.026l-.258-.151c0,1.852,0,5.469,0,6.628l5.793,3.32Z",
    transform: "translate(-39.789 -93.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72068",
    "data-name": "Path 72068",
    className: "cls-89",
    d: "M90.085,136.775l5.712,3.4V138.9l-5.712-3.4Zm-.912-1.8-5.267-3.064v1.276l5.267,3.064Zm4.856-.038-10.124-5.97v1.276l10.124,5.97Z",
    transform: "translate(-53.813 -82.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72069",
    "data-name": "Path 72069",
    className: "cls-90",
    d: "M67.832,118.294l-5.791-3.5c0,1.852,0,5.47,0,6.628l5.793,3.32Z",
    transform: "translate(-39.789 -73.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72070",
    "data-name": "Path 72070",
    className: "cls-89",
    d: "M67.832,124.139,62.3,120.969c0-1.029,0-4.455,0-6.026l-.258-.151c0,1.852,0,5.47,0,6.628l5.793,3.32Z",
    transform: "translate(-39.789 -73.622)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68001",
    "data-name": "Group 68001",
    transform: "translate(23.13 65.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68000",
    "data-name": "Group 68000",
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25480",
    "data-name": "Rectangle 25480",
    className: "cls-3",
    width: 4.336,
    height: 6.433,
    transform: "translate(-0.018)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68003",
    "data-name": "Group 68003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68002",
    "data-name": "Group 68002",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72073",
    "data-name": "Path 72073",
    className: "cls-92",
    d: "M68.1,124.729a1.081,1.081,0,0,1,.377.4c.206.357.205.744,0,.863l-2.8,1.594a.38.38,0,0,1-.376-.039,1.092,1.092,0,0,1-.377-.4l-.987-1.709c-.206-.357-.2-.744,0-.865a.381.381,0,0,1,.377.039,1.077,1.077,0,0,1,.376.4l.612,1.061,2.419-1.378a.375.375,0,0,1,.376.037",
    transform: "translate(-40.909 -79.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72074",
    "data-name": "Path 72074",
    className: "cls-6",
    d: "M81.791,30.016,44.265,8.26a2.807,2.807,0,0,0-2.683-.29l-.023-.025-1.3.9.008.029a2.73,2.73,0,0,1,2.832.206L80.624,30.83c2.372,1.37,4.3,5.044,4.3,8.208V55.687a4.1,4.1,0,0,1-1.2,3.268l.263-.379a3.867,3.867,0,0,0,2.1-3.7V38.223c0-3.163-1.923-6.838-4.3-8.207",
    transform: "translate(-25.819 -4.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72075",
    "data-name": "Path 72075",
    className: "cls-7",
    d: "M78.021,32.283,40.5,10.527c-2.372-1.37-4.3.084-4.3,3.248V30.424c0,3.163,1.923,6.838,4.3,8.207L78.021,60.386c2.372,1.37,4.3-.084,4.3-3.247V40.49c0-3.163-1.923-6.838-4.3-8.208",
    transform: "translate(-23.217 -6.421)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68005",
    "data-name": "Group 68005",
    transform: "translate(13.68 4.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68004",
    "data-name": "Group 68004",
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25482",
    "data-name": "Rectangle 25482",
    className: "cls-94",
    width: 65.505,
    height: 66.445,
    transform: "matrix(0.799, -0.602, 0.602, 0.799, -23.789, 17.926)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68030",
    "data-name": "Group 68030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68029",
    "data-name": "Group 68029",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73764",
    "data-name": "Group 73764",
    transform: "translate(17.096 20.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72077",
    "data-name": "Path 72077",
    className: "cls-95",
    d: "M86.595,95.184V93.836l-11.931-6.8v1.347Z",
    transform: "translate(-64.982 -75.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72078",
    "data-name": "Path 72078",
    className: "cls-95",
    d: "M60.819,71.3,47.668,63.708v1.347l13.152,7.588Z",
    transform: "translate(-47.668 -60.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72079",
    "data-name": "Path 72079",
    className: "cls-95",
    d: "M51.454,58.151,47.668,55.9V57.25L51.454,59.5Z",
    transform: "translate(-47.668 -55.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72080",
    "data-name": "Path 72080",
    className: "cls-95",
    d: "M61.924,64.306v1.347L92,82.772V81.425Z",
    transform: "translate(-56.811 -61.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72081",
    "data-name": "Path 72081",
    className: "cls-95",
    d: "M88.036,87v1.347L99.093,94.74V93.393Z",
    transform: "translate(-73.558 -75.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72082",
    "data-name": "Path 72082",
    className: "cls-95",
    d: "M122.565,108.311l11.426,6.4v-1.347l-11.426-6.4Z",
    transform: "translate(-95.703 -88.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72083",
    "data-name": "Path 72083",
    className: "cls-95",
    d: "M56.024,76.286l-8.356-4.818v1.347l8.356,4.818Z",
    transform: "translate(-47.668 -65.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72084",
    "data-name": "Path 72084",
    className: "cls-95",
    d: "M112.341,109.715c0,.406-.287.569-.64.365a1.411,1.411,0,0,1-.64-1.1c0-.406.287-.569.64-.365a1.411,1.411,0,0,1,.64,1.1",
    transform: "translate(-88.325 -89.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72085",
    "data-name": "Path 72085",
    className: "cls-95",
    d: "M117.833,112.886c0,.406-.287.569-.64.365a1.411,1.411,0,0,1-.64-1.1c0-.406.287-.569.64-.365a1.411,1.411,0,0,1,.64,1.1",
    transform: "translate(-91.847 -91.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72086",
    "data-name": "Path 72086",
    className: "cls-95",
    d: "M123.325,116.057c0,.406-.287.569-.64.365a1.411,1.411,0,0,1-.64-1.1c0-.406.287-.569.64-.365a1.411,1.411,0,0,1,.64,1.1",
    transform: "translate(-95.37 -93.719)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72088",
    "data-name": "Path 72088",
    className: "cls-6",
    d: "M15.149,62.913l-7.305-4.25a2.728,2.728,0,0,0-2.61-.282l-.023-.025-1.266.87.009.028a2.655,2.655,0,0,1,2.754.2l7.306,4.25c2.307,1.332,4.178,4.906,4.178,7.983V76.6a3.987,3.987,0,0,1-1.163,3.179l.256-.369a3.76,3.76,0,0,0,2.043-3.6V70.9c0-3.076-1.87-6.65-4.178-7.982",
    transform: "translate(-2.53 -37.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72089",
    "data-name": "Path 72089",
    className: "cls-7",
    d: "M11.483,65.118l-7.305-4.25C1.87,59.536,0,60.95,0,64.026v4.916c0,3.076,1.87,6.65,4.178,7.982l7.305,4.25c2.308,1.332,4.178-.082,4.178-3.158V73.1c0-3.077-1.87-6.65-4.178-7.983",
    transform: "translate(0 -38.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72090",
    "data-name": "Path 72090",
    className: "cls-96",
    d: "M14.353,82.21a2.681,2.681,0,0,1-1.32-.411L5.728,77.55c-2.081-1.2-3.839-4.588-3.839-7.4V65.238c0-1.812.723-2.982,1.842-2.982a2.681,2.681,0,0,1,1.32.411l7.3,4.25c2.082,1.2,3.84,4.589,3.84,7.4v4.916a4,4,0,0,1-.58,2.3,1.487,1.487,0,0,1-1.262.685",
    transform: "translate(-1.212 -39.928)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68019",
    "data-name": "Group 68019",
    className: "cls-97",
    transform: "translate(2.926 26.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68018",
    "data-name": "Group 68018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68017",
    "data-name": "Group 68017",
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68013",
    "data-name": "Group 68013",
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68012",
    "data-name": "Group 68012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68011",
    "data-name": "Group 68011",
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72091",
    "data-name": "Path 72091",
    className: "cls-101",
    d: "M8.659,78.452c-.291-.062-.5.128-.5.5a1.585,1.585,0,0,0,.719,1.241l2.866,1.655v1.677a2.4,2.4,0,0,0,1.09,1.881c.193.111.349.022.349-.2V83.786a1.01,1.01,0,0,1,.379-.886l1.363-.89v.431a.846.846,0,0,0,.384.662l1.136.642c.212.122.384.024.384-.219V79.093a.846.846,0,0,0-.384-.662l-1.136-.642c-.208-.12-.376-.026-.382.207a1.441,1.441,0,0,0-.587-.766l-1.551-.9-1.933-1.116-1.035-.6c-.385-.222-.719-.078-.74.351a1.362,1.362,0,0,0,.158.655c-.388-.211-.7-.027-.7.421a1.569,1.569,0,0,0,.371.937L8.9,76.979c-.393-.227-.731-.071-.742.373a1.591,1.591,0,0,0,.5,1.1",
    transform: "translate(-8.157 -74.517)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68016",
    "data-name": "Group 68016",
    className: "cls-99",
    transform: "translate(0.978 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68015",
    "data-name": "Group 68015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68014",
    "data-name": "Group 68014",
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72092",
    "data-name": "Path 72092",
    className: "cls-103",
    d: "M27.183,83.759l1.136.642a.845.845,0,0,1,.384.662V89.5a.335.335,0,0,1-.01.053c.148.025.256-.072.256-.263V84.852a.846.846,0,0,0-.384-.662l-1.136-.642c-.194-.112-.346-.033-.373.166a.354.354,0,0,1,.127.044",
    transform: "translate(-21.256 -80.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72093",
    "data-name": "Path 72093",
    className: "cls-103",
    d: "M21.853,98.389a1.01,1.01,0,0,0-.379.886v1.417c0,.009,0,.014,0,.022.143.033.25-.052.25-.233V99.065a1.175,1.175,0,0,1,.209-.725Z",
    transform: "translate(-17.673 -89.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72094",
    "data-name": "Path 72094",
    className: "cls-103",
    d: "M11.323,74.833l1.035.6,1.933,1.116,1.551.9a1.438,1.438,0,0,1,.587.766c0-.17.1-.264.226-.256a1.424,1.424,0,0,0-.567-.721l-1.551-.9L12.6,75.22l-1.035-.6c-.3-.176-.574-.119-.685.123a.6.6,0,0,1,.44.088",
    transform: "translate(-10.883 -74.52)"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72095",
    "data-name": "Path 72095",
    className: "cls-6",
    d: "M27.191,123.894l-4.529-2.635a1.691,1.691,0,0,0-1.618-.175l-.014-.015-.785.539.005.018a1.645,1.645,0,0,1,1.708.124l4.529,2.635a6.2,6.2,0,0,1,2.59,4.949v3.047a2.472,2.472,0,0,1-.721,1.971l.159-.228a2.331,2.331,0,0,0,1.267-2.233v-3.048a6.2,6.2,0,0,0-2.59-4.949",
    transform: "translate(-12.984 -77.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72096",
    "data-name": "Path 72096",
    className: "cls-7",
    d: "M24.918,125.261l-4.529-2.635c-1.43-.826-2.59.051-2.59,1.958v3.047a6.2,6.2,0,0,0,2.59,4.949l4.529,2.635c1.431.826,2.59-.051,2.59-1.958V130.21a6.2,6.2,0,0,0-2.59-4.949",
    transform: "translate(-11.415 -78.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72097",
    "data-name": "Path 72097",
    className: "cls-104",
    d: "M26.7,135.857a1.664,1.664,0,0,1-.818-.255l-4.529-2.635a5.839,5.839,0,0,1-2.38-4.585v-3.048c0-1.123.448-1.849,1.142-1.849a1.662,1.662,0,0,1,.818.255l4.528,2.635a5.839,5.839,0,0,1,2.381,4.585v3.047a2.485,2.485,0,0,1-.359,1.425.922.922,0,0,1-.783.424",
    transform: "translate(-12.166 -79.198)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68028",
    "data-name": "Group 68028",
    className: "cls-97",
    transform: "translate(8.711 47.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68027",
    "data-name": "Group 68027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68026",
    "data-name": "Group 68026",
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68022",
    "data-name": "Group 68022",
    className: "cls-99",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68021",
    "data-name": "Group 68021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68020",
    "data-name": "Group 68020",
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72098",
    "data-name": "Path 72098",
    className: "cls-107",
    d: "M29.6,136.654c.189.041.326-.084.326-.323a1.032,1.032,0,0,0-.468-.808L27.6,134.446v-1.091a1.564,1.564,0,0,0-.709-1.224c-.126-.072-.227-.015-.227.129v.922a.656.656,0,0,1-.247.576l-.887.58v-.281a.551.551,0,0,0-.25-.431l-.74-.417c-.138-.08-.25-.016-.25.142v2.885a.55.55,0,0,0,.25.431l.74.418c.135.078.244.017.248-.135a.937.937,0,0,0,.382.5l1.009.583,1.258.727.674.389c.251.145.468.051.482-.228a.885.885,0,0,0-.1-.427c.252.137.455.018.455-.274a1.019,1.019,0,0,0-.242-.609l.007,0c.256.148.476.047.483-.243a1.036,1.036,0,0,0-.326-.716",
    transform: "translate(-24.289 -132.1)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68025",
    "data-name": "Group 68025",
    className: "cls-99",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68024",
    "data-name": "Group 68024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68023",
    "data-name": "Group 68023",
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72099",
    "data-name": "Path 72099",
    className: "cls-109",
    d: "M25.437,138.877l-.739-.417a.55.55,0,0,1-.25-.431v-2.885a.25.25,0,0,1,.007-.034c-.1-.016-.167.047-.167.171v2.885a.55.55,0,0,0,.25.431l.739.417c.126.073.226.021.242-.108a.239.239,0,0,1-.082-.029",
    transform: "translate(-24.288 -134.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72100",
    "data-name": "Path 72100",
    className: "cls-109",
    d: "M30.573,133.63a.657.657,0,0,0,.247-.576v-.922c0-.006,0-.009,0-.015-.094-.021-.163.034-.163.152v.922a.763.763,0,0,1-.136.472Z",
    transform: "translate(-28.288 -132.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72101",
    "data-name": "Path 72101",
    className: "cls-109",
    d: "M31.244,147.44l-.674-.389-1.258-.727-1.01-.583a.934.934,0,0,1-.382-.5c0,.111-.062.172-.147.167a.928.928,0,0,0,.369.469l1.01.583,1.258.727.673.389c.2.114.374.077.446-.08a.387.387,0,0,1-.286-.057",
    transform: "translate(-26.524 -140.534)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73765",
    "data-name": "Group 73765",
    className: "cls-110",
    transform: "translate(12.984 20.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68008",
    "data-name": "Group 68008",
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68007",
    "data-name": "Group 68007",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68006",
    "data-name": "Group 68006",
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25483",
    "data-name": "Rectangle 25483",
    className: "cls-4",
    width: 11.239,
    height: 21.055,
    transform: "translate(-1.745 0.151) rotate(-4.947)"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72102",
    "data-name": "Path 72102",
    className: "cls-92",
    d: "M68.1,124.729a1.081,1.081,0,0,1,.377.4c.206.357.205.744,0,.863l-2.8,1.594a.38.38,0,0,1-.376-.039,1.092,1.092,0,0,1-.377-.4l-.987-1.709c-.206-.357-.2-.744,0-.865a.381.381,0,0,1,.377.039,1.077,1.077,0,0,1,.376.4l.612,1.061,2.419-1.378a.375.375,0,0,1,.376.037",
    transform: "translate(-40.909 -68.757)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68037",
    "data-name": "Group 68037",
    transform: "translate(1347.29 562.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67737",
    "data-name": "Group 67737",
    className: "cls-113",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71858",
    "data-name": "Path 71858",
    className: "cls-114",
    d: "M29.022,15.653c-.5.077-1.388.24-1.379.828s.812,1.214.812,1.214a6.039,6.039,0,0,0,.567-2.042",
    transform: "translate(-21.155 -6.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71859",
    "data-name": "Path 71859",
    className: "cls-115",
    d: "M3.69,18.088a6.5,6.5,0,0,1,2.464-4.157c.62-.412,1.647.24,2.275,1.08a44.3,44.3,0,0,1,2.19,5.517c.718-.417,1.444,0,.736.8.642.027.84.356.84,1.455a7.75,7.75,0,0,1,2.694,2.568c.424,1.035.52,2.171-.675,2.677-1.274.538-2.63,1.165-3.6.47a17.733,17.733,0,0,1-4.169-4.739c-1.043-1.541-3.052-3.8-2.759-5.673",
    transform: "translate(7.169 -5.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71860",
    "data-name": "Path 71860",
    className: "cls-116",
    d: "M15.761,20.136l.493,1.338a6.459,6.459,0,0,1-2.016,1.81c-1.351.791-1.651.725-1.651.725l-.445-1.49a15.725,15.725,0,0,0,3.62-2.383",
    transform: "translate(0.977 -7.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71861",
    "data-name": "Path 71861",
    className: "cls-115",
    d: "M4.8,45.254c1.105-1.5,5.65-2.743,5.727-2.637a37.944,37.944,0,0,1,3.811,6.31A23.76,23.76,0,0,1,15.5,52.075a43.164,43.164,0,0,1,1.622,4.269c.158.894,0,1.314-.479,2.988-.7,2.467-.4,5.62-1.558,6.238-.12.064-1.989,1.018-2.925.658a3.422,3.422,0,0,1-2.163-1.971c-.88-1.775.144-4.069.3-6.022.037-.462.64-.864.672-.99-.374-.051-.939-.121-1.144-.473-.225-.384.094-.628-.327-.911-.356-.238-1.036-.582-1.362-.856A10.907,10.907,0,0,1,4.8,50.546c-.61-1.6-1.109-3.782,0-5.292",
    transform: "translate(4.88 -16.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71862",
    "data-name": "Path 71862",
    className: "cls-116",
    d: "M16.566,53.689S14.916,54.8,12.9,56.08s-3.4,2.257-3.4,2.257l-1.4-1.47s2.446-1.907,4.3-3.125a19.057,19.057,0,0,1,3.391-1.81Z",
    transform: "translate(3.107 -20.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71863",
    "data-name": "Path 71863",
    className: "cls-117",
    d: "M20.521,64.856c-.623-.87.17-1.365.744-1.549a12.2,12.2,0,0,1-.512-2.135c-.274-1.4.338-2.537.809-3.848-.333-1.933-1.172-3.7-.9-5.641.154-1.082-.017-4.239.889-6.858.371-1.072,8.738-1.018,8.881-.3.218,1.1.269,3.314.353,4.547a8.233,8.233,0,0,1-.945,4.037c-.18.444-1.618,5.769-1.717,6.708-.151,1.441-.352,4.559-1.477,5.379a1.084,1.084,0,0,1,.477.884c-.054.34-.316.372-.511.59-.485.54-.225,1.545-.287,2.289-.09,1.086.437,2.05-.458,2.236-.092,1.007-3.871,3.518-6.394.442-1.246-1.414.68-6.067,1.042-6.782",
    transform: "translate(-17.755 -17.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71864",
    "data-name": "Path 71864",
    className: "cls-117",
    d: "M15.432,21.7c.877-2.264,3.706-3.563,4.322-3.755.4-.187,6.022-1.114,6.777-1.257,1.411,1.793,1.981,4.118,1.59,7.511-.209,1.82.141,2.586.391,4.4a3.494,3.494,0,0,1-.267,2.289c-.072,1.07-2.016,3.731-6.23,4.022-1.318.091-4.927-1.831-5.19-2.318a18.613,18.613,0,0,1-1.636-4.979c-.216-2.112-.554-3.857.243-5.915",
    transform: "translate(-13.024 -6.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71865",
    "data-name": "Path 71865",
    className: "cls-116",
    d: "M25.807,33.966a10.732,10.732,0,0,1-4.83,2.239c-3.562.511-4.431-.217-5.93-.482a3.287,3.287,0,0,0,.08,1.283,13.959,13.959,0,0,0,6.047.54,11.85,11.85,0,0,0,4.81-2.311,2.9,2.9,0,0,0-.177-1.268",
    transform: "translate(-10.519 -13.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71866",
    "data-name": "Path 71866",
    className: "cls-116",
    d: "M26.6,30a11.842,11.842,0,0,1-4.988,2.239c-3.561.511-4.43-.217-5.93-.482a3.281,3.281,0,0,0,.081,1.283,13.955,13.955,0,0,0,6.046.54,12.174,12.174,0,0,0,4.851-2.284c0-.52-.06-1.3-.06-1.3",
    transform: "translate(-11.554 -11.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71867",
    "data-name": "Path 71867",
    className: "cls-118",
    d: "M25.1,14.93c.287,1,1.115,2.171.35,3.19-.912,1.215-2.671-.3-3.6-.792A8.48,8.48,0,0,1,20.015,16a6.867,6.867,0,0,0,.9-2.214,7.911,7.911,0,0,1,.492-2.012,13.14,13.14,0,0,1,3.65,1.793A2.576,2.576,0,0,0,25.1,14.93",
    transform: "translate(-13.284 -4.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71868",
    "data-name": "Path 71868",
    className: "cls-119",
    d: "M19.91,3.556a3.859,3.859,0,0,1,3.827.25,3.845,3.845,0,0,1,1.187,1.95A3.25,3.25,0,0,1,25.26,7.07,14.871,14.871,0,0,1,24.9,9.891c-.126.637-.77.85-1.24,1.171-1.194.812-2.542-.036-3.551-.748-1.1-.776-2.3-1.758-2.471-3.184A3.546,3.546,0,0,1,19.91,3.556",
    transform: "translate(-11.333 -1.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71869",
    "data-name": "Path 71869",
    className: "cls-120",
    d: "M27.838,7.71a2.856,2.856,0,0,1-2.14,2.318c-.124.588-.492,2.012-.492,2.012a4.781,4.781,0,0,1-1.494-2.65,6.573,6.573,0,0,1,.143-2.018Z",
    transform: "translate(-17.577 -2.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71870",
    "data-name": "Path 71870",
    className: "cls-119",
    d: "M27.158,11.078s-.346-1.389-1.114-.646.442,1.664.442,1.664Z",
    transform: "translate(-18.167 -4.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71871",
    "data-name": "Path 71871",
    className: "cls-121",
    d: "M21.7,5.228s1.726.885,1.981,2.052l.033,0v.3h0a1.533,1.533,0,0,1-.477,1.04c-.862.912-2.79,1.2-4.669.75A4.586,4.586,0,0,1,15.826,7.55Z",
    transform: "translate(-8.703 -2.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71872",
    "data-name": "Path 71872",
    className: "cls-122",
    d: "M23.229,8.17c-.862.912-2.791,1.2-4.67.75A4.584,4.584,0,0,1,15.825,7.1l5.869-2.322s3.2,1.637,1.535,3.4",
    transform: "translate(-8.702 -1.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71873",
    "data-name": "Path 71873",
    className: "cls-121",
    d: "M18.766,1.253a2.422,2.422,0,0,0,.6,2.269,5.287,5.287,0,0,0,3.712,1.589A1.853,1.853,0,0,0,25.1,3.716a4.07,4.07,0,0,1,.088.842c0,.051-.016.307-.034.428h0c-.142,1.117-1.89,2-4.026,2s-3.884-.883-4.026-2h0a2,2,0,0,1-.034-.428,4.056,4.056,0,0,1,1.7-3.305",
    transform: "translate(-10.929 -0.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71874",
    "data-name": "Path 71874",
    className: "cls-123",
    d: "M21.606,4.614a5.286,5.286,0,0,1-3.712-1.588,2.422,2.422,0,0,1-.6-2.27,4.061,4.061,0,0,1,6.333,2.463,1.853,1.853,0,0,1-2.025,1.395",
    transform: "translate(-9.461 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71875",
    "data-name": "Path 71875",
    className: "cls-124",
    d: "M20.19,2.376a3.685,3.685,0,0,1,3.166,1.1A4.87,4.87,0,0,1,24.79,6.941c0,.026-.041.034-.048.006a14,14,0,0,0-.387-1.628A4.831,4.831,0,0,0,23.346,3.66,3.99,3.99,0,0,0,20.2,2.427c-.029,0-.036-.046-.007-.051",
    transform: "translate(-12.413 -0.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71876",
    "data-name": "Path 71876",
    className: "cls-122",
    d: "M18.214.552a1.067,1.067,0,0,1,.964.073A4.137,4.137,0,0,1,20.8,1.907a1.826,1.826,0,0,1,.482,1.185c-.038.235-.184.441-.424.308-.359-.2-.521-.735-.7-1.071A3.013,3.013,0,0,0,19,1.1c-.166-.1-1.05-.357-.788-.543",
    transform: "translate(-7.699 -0.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71877",
    "data-name": "Path 71877",
    className: "cls-125",
    d: "M18.506,2.925c.177-.1.7.649.7.933.006.267-.18.369-.354.118a2.112,2.112,0,0,1-.238-.458c-.04-.1-.248-.52-.113-.593",
    transform: "translate(-5.795 -1.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71878",
    "data-name": "Path 71878",
    className: "cls-126",
    d: "M17.261,5.161l-.022-.1c.009.034.016.068.022.1",
    transform: "translate(-3.108 -2.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71879",
    "data-name": "Path 71879",
    className: "cls-126",
    d: "M17.276,5.025l0,.019Z",
    transform: "translate(-3.15 -1.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71880",
    "data-name": "Path 71880",
    className: "cls-127",
    d: "M17.064,5.875v0a3.776,3.776,0,0,1,.155-.963h0a1.163,1.163,0,0,0-.068.387c0,1.167,1.777,2.112,3.971,2.112s3.971-.945,3.971-2.112a1.165,1.165,0,0,0-.018-.195,3.975,3.975,0,0,1,.106.906l0,.01c-.043,1.173-1.843,2.117-4.06,2.117-2.243,0-4.061-.967-4.061-2.16,0-.033,0-.066,0-.1",
    transform: "translate(-10.924 -1.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71881",
    "data-name": "Path 71881",
    className: "cls-120",
    d: "M17.11,7.794a1.523,1.523,0,0,1,.636-1.215.412.412,0,0,1,.391-.042L18.6,6.8l-.255.538a1.665,1.665,0,0,1-.328.69l-.252.532-.436-.256a.555.555,0,0,1-.223-.511",
    transform: "translate(-4.372 -2.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71882",
    "data-name": "Path 71882",
    className: "cls-128",
    d: "M17.385,7a1.523,1.523,0,0,0-.636,1.215c0,.468.285.684.636.481a1.524,1.524,0,0,0,.636-1.215c0-.468-.285-.684-.636-.481",
    transform: "translate(-3.573 -2.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71883",
    "data-name": "Path 71883",
    className: "cls-129",
    d: "M17.448,7.249a1.3,1.3,0,0,0-.541,1.033c0,.4.242.581.541.409a1.294,1.294,0,0,0,.541-1.033c0-.4-.242-.581-.541-.409",
    transform: "translate(-3.635 -2.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71896",
    "data-name": "Path 71896",
    className: "cls-122",
    d: "M22.117,3.968a.972.972,0,0,1,.686.289,2.607,2.607,0,0,1,.837,1.188c.019.146-.054.256-.209.247-.275-.015-.569-.4-.752-.564C22.536,5,21.488,4.1,22.117,3.968",
    transform: "translate(-12.314 -1.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71897",
    "data-name": "Path 71897",
    className: "cls-125",
    d: "M22.241,4.948c.282-.212.732.526.747.707.005.072-.011.156-.091.176-.125.033-.274-.125-.351-.2-.1-.1-.529-.512-.3-.681",
    transform: "translate(-11.815 -1.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71898",
    "data-name": "Path 71898",
    className: "cls-114",
    d: "M20.492,17a3.9,3.9,0,0,1,.713,1.017,2.247,2.247,0,0,1,.075,1.333,2.2,2.2,0,0,1-1.138,1.435,1.851,1.851,0,0,0,.153-.908c-.025-.36-.282-.885-.286-1.12a3.708,3.708,0,0,0-.552-1.581Z",
    transform: "translate(-8.534 -6.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71899",
    "data-name": "Path 71899",
    className: "cls-120",
    d: "M23.362,12.8a9.518,9.518,0,0,1-.489,3.219,2.969,2.969,0,0,1-3.9.474c-1.547-1-.927-3.694-.927-3.694s.6,1.69,1.234,1.859c.9.241,1.464-.364,2.37-.632.956-.284,1.119-.07,1.418-.309.159-.127.1-.5.3-.918",
    transform: "translate(-9.62 -5.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71900",
    "data-name": "Path 71900",
    className: "cls-119",
    d: "M20.526,15.416l.558.209a1,1,0,0,1-.529.645.768.768,0,0,1-1.065-.237Z",
    transform: "translate(-8.29 -6.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71901",
    "data-name": "Path 71901",
    className: "cls-120",
    d: "M5.06,85.222c.018-.025.036-.039.054-.062a63.191,63.191,0,0,1,.594-6.685,2.576,2.576,0,0,0,1.924,1.368,4.563,4.563,0,0,0,2.981-.021A56.416,56.416,0,0,1,9.04,85.394,5.722,5.722,0,0,0,10.7,86.762a3.909,3.909,0,0,1,1.451,1.155c.4.563.64,1.644.164,2.115s-1.7.786-3.368.24a3.952,3.952,0,0,1-2.726-2.192c-.456.13-1.477-.3-1.509-.6a3.463,3.463,0,0,1,.354-2.257",
    transform: "translate(9.167 -31.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71902",
    "data-name": "Path 71902",
    className: "cls-120",
    d: "M28.113,95.225A55.288,55.288,0,0,1,26.3,89.5a6.681,6.681,0,0,0,3.5.594,5.988,5.988,0,0,0,2.9-1.036s-.255,3.349-.528,5.393a2.4,2.4,0,0,0,.273,1.66,25.052,25.052,0,0,1,.684,2.477,2.025,2.025,0,0,1-.486,2.289,4.312,4.312,0,0,1-2.683.476c-.844-.11-1.426-1.013-1.689-1.826a5.629,5.629,0,0,1-.066-2.917c-.422-.621-.033-1.018-.089-1.386",
    transform: "translate(-24.578 -35.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71903",
    "data-name": "Path 71903",
    className: "cls-120",
    d: "M10.121,35.7a16.5,16.5,0,0,1,3.23-1.345,4,4,0,0,1,3.639.683c.833.707.113,1.035-.282.971s-1.24-.309-1.24-.309-.263,1.981-1.326,2.133-2.545,1.093-3.353.656-.669-2.789-.669-2.789",
    transform: "translate(1.079 -13.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71904",
    "data-name": "Path 71904",
    className: "cls-114",
    d: "M26.58,40.221l.186,1.449A6.62,6.62,0,0,1,21.7,44.457a15.07,15.07,0,0,1-6.538-1.13v-1.4a22.289,22.289,0,0,0,6.208.754,10.026,10.026,0,0,0,5.212-2.458",
    transform: "translate(-11.359 -15.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71905",
    "data-name": "Path 71905",
    className: "cls-115",
    d: "M20.665,25.279c.85-2.951,2.695-4.55,4.374-4.087.923.255,2.061,3.033,1.5,5.853-.2,1.018-1.173,3.629-.929,4.964a.892.892,0,0,1,1.01.422,19.6,19.6,0,0,1,4.32-2.2c.829,0,2.263,2.766,1.425,3.878-.78.126-4.641,2.98-6.381,3.391-2.421.572-2.229.151-3.319-.664-.957-.716-1.7-3.32-2.1-5.047a23.563,23.563,0,0,1,.1-6.508",
    transform: "translate(-20.37 -8.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71906",
    "data-name": "Path 71906",
    className: "cls-130",
    d: "M12.329,33.525l.381.214L9.777,40.623,9.4,40.408Z",
    transform: "translate(6.176 -13.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71907",
    "data-name": "Path 71907",
    className: "cls-131",
    d: "M6.454,28.9l-.381-.214L1.015,31.606l.381.214Z",
    transform: "translate(17.49 -11.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71908",
    "data-name": "Path 71908",
    className: "cls-128",
    d: "M6.034,37.32,0,40.8l3.5-8.211,6.034-3.484Z",
    transform: "translate(15.025 -11.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71909",
    "data-name": "Path 71909",
    className: "cls-120",
    d: "M13.5,34.458l.454.255-3.5,8.211L10,42.669Z",
    transform: "translate(4.574 -13.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71910",
    "data-name": "Path 71910",
    className: "cls-132",
    d: "M6.488,28.942l-.454-.255L0,32.169l.454.256Z",
    transform: "translate(18.069 -11.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71911",
    "data-name": "Path 71911",
    className: "cls-114",
    d: "M20.614,22.338a8.709,8.709,0,0,1,.689,2.193,11.039,11.039,0,0,1,0,2.125l-1.165.489a10.633,10.633,0,0,0,0-2.362,8.583,8.583,0,0,0-.725-1.818Z",
    transform: "translate(-8.516 -8.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71912",
    "data-name": "Path 71912",
    className: "cls-114",
    d: "M21.4,18.659c.043-.145-.007-.93-.007-1.634,1.015,1.095,2.194,1.256,3.184,1.742.824.4,1.93,1.327,1.977,2.175a11.033,11.033,0,0,1-3.558-.857c-.926-.351-1.684-1.127-1.6-1.425",
    transform: "translate(-14.902 -6.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71913",
    "data-name": "Path 71913",
    className: "cls-120",
    d: "M4.3,33.739c1.014.121.546,2.86-.443,3.414s-2.277,1.2-2.738.364S2.3,33.5,4.3,33.739",
    transform: "translate(19.069 -13.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71914",
    "data-name": "Path 71914",
    className: "cls-116",
    d: "M36.96,33.124a10.712,10.712,0,0,1-3.169-.161A5.258,5.258,0,0,1,31.3,31.791a8.075,8.075,0,0,0,.048,1.61,3.519,3.519,0,0,0,2.44,1.027,11.494,11.494,0,0,0,2.854.007Z",
    transform: "translate(-31.284 -12.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71915",
    "data-name": "Path 71915",
    className: "cls-116",
    d: "M30.025,60.788a13.513,13.513,0,0,1-4.357.422A32.93,32.93,0,0,1,21.31,60.2s.45,1.9.45,1.9a17.59,17.59,0,0,0,3.763,1.058,11.593,11.593,0,0,0,3.967-.42Z",
    transform: "translate(-18.329 -23.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71916",
    "data-name": "Path 71916",
    className: "cls-114",
    d: "M31.025,82.707a6.254,6.254,0,0,1-2.2.8,3.771,3.771,0,0,1-1.185-.486s2.694-.628,3.382-.316",
    transform: "translate(-23.152 -32.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71917",
    "data-name": "Path 71917",
    className: "cls-114",
    d: "M29.536,74.982a11.109,11.109,0,0,0,1.579,1.563,6.373,6.373,0,0,1,1.055.922s-1.862-.348-2.24-.922a3.532,3.532,0,0,1-.394-1.563",
    transform: "translate(-25.439 -29.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71918",
    "data-name": "Path 71918",
    className: "cls-114",
    d: "M27.551,49.568a2.012,2.012,0,0,1-.768,1.314,9.824,9.824,0,0,1-1.12.742,4.129,4.129,0,0,1,.693-1.159,4.791,4.791,0,0,1,1.194-.9",
    transform: "translate(-18.483 -19.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71919",
    "data-name": "Path 71919",
    className: "cls-114",
    d: "M32.835,41.275a2.961,2.961,0,0,1-.262,1.6,3.085,3.085,0,0,1-1.317.994,3.822,3.822,0,0,1,.673-1.3c.545-.727.906-1.3.906-1.3",
    transform: "translate(-27.159 -16.363)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreStartChecks);
export default __webpack_public_path__ + "static/media/PreStartChecks.141fd905eddce0f7148e51e896622d4f.svg";
export { ForwardRef as ReactComponent };